import {
  Avatar, Box, Button, ButtonGroup, Card, CardActionArea, CardContent, Chip, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogContentText,
  DialogTitle, Divider, FormControlLabel, Grid, IconButton, makeStyles, Menu, MenuItem, Paper, Radio, RadioGroup, Switch, TextField,
  Typography, useMediaQuery
} from '@material-ui/core'
import { fade } from '@material-ui/core/styles/colorManipulator'
import { CommentOutlined } from '@material-ui/icons'
import EditIcon from '@material-ui/icons/Edit'
import MenuIcon from '@material-ui/icons/Menu'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import Layout from '../../../../components/layout'
import { byLabel, CoverLetter, Document } from '../../../job-offer/[pid]/apply'
import { mapByIds, useAuth, useFetch } from '../../../../components/context/useFetch'
import Imageviewer from '../../../../components/imageviewer'
import { ProfilePic } from '../../mycandidates'
import { pictureUrl } from '../../../../components/common/pictureUrl'
import { BackgroundViewer } from '../../../../components/backgroundViewer'
import { useAlert, useUpdate, useBatch, useChangeHandler } from '../../../../components/reducer'
import { Trans } from 'react-i18next'
import Head from 'next/head'
import SubdirectoryArrowRightIcon from '@material-ui/icons/SubdirectoryArrowRight'
import { Alert, Autocomplete } from '@material-ui/lab'
import i18n from 'i18next'
import moment from 'moment'
import { useRouter } from 'next/router'
import { Fragment, useEffect, useState } from 'react'
import ReactMarkdown from 'react-markdown'
import { useSelector } from 'react-redux'
import { default as ApplicationStatuses, default as STATUSES, useStatusesStyles } from '../../../../components/application_status'
import { CHIP_COLORS } from '../../../../components/dashboard/News'
import MarkdownEditor from '../../../../components/utils/markdown-editor'
import { multiWordInitials } from '../../../../components/utils/multiWordInitials'
import { PortfolioContent } from '../../../t/[pid]'
import { Navigation } from '../../../../components/job-offer/Navigation'
import { InterviewDialog } from '../../../../components/dashboard/interviews'
import allPagesProps from '../../../../components/common/all_pages_props'

const useStyles = makeStyles((theme) => ({
  paperStyle: {
    '&:hover': {
      boxShadow: '0px 4px 8px rgba(38, 38, 38, 0.5)'
    }
  },
  large: {
    width: theme.spacing(40),
    height: theme.spacing(40)
  },
  info: {
    padding: theme.spacing(1)
  },
  margin: {
    width: '100%'
  },
  root: {
    maxWidth: 345
  },
  media: {
    [theme.breakpoints.down('xs')]: {
      height: '100%'
    }
  },
  textt: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.9rem'
    }
  },
  pendingButton: {
    textTransform: 'inherit',
    [theme.breakpoints.down('xs')]: {
      fontSize: '11px'
    }
  },
  selectedButton: {
    color: theme.palette.success.dark,
    borderColor: theme.palette.success.dark,
    '&.ge--MuiButton-contained': {
      backgroundColor: fade(theme.palette.success.main, 0.3),
    },
    [theme.breakpoints.down('xs')]: {
      textTransform: 'inherit',
      fontSize: '11px',
      paddingLeft: '5px',
      paddingRight: '5px'
    }
  },
  maybeButton: {
    color: theme.palette.warning.dark,
    borderColor: theme.palette.warning.dark,
    '&.ge--MuiButton-contained': {
      backgroundColor: fade(theme.palette.warning.main, 0.3),
    },
    [theme.breakpoints.down('xs')]: {
      textTransform: 'inherit',
      fontSize: '11px',
      paddingLeft: '5px',
      paddingRight: '5px'
    }
  },
  rejectedButton: {
    color: theme.palette.error.dark,
    borderColor: theme.palette.error.dark,
    '&.ge--MuiButton-contained': {
      backgroundColor: fade(theme.palette.error.main, 0.3),
    },
    [theme.breakpoints.down('xs')]: {
      textTransform: 'inherit',
      fontSize: '11px',
      paddingLeft: '5px',
      paddingRight: '5px'
    }
  },
  hiredButton: {
    color: theme.palette.primary.dark,
    borderColor: theme.palette.primary.dark,
    '&.ge--MuiButton-contained': {
      backgroundColor: fade(theme.palette.primary.main, 0.3),
    },
    [theme.breakpoints.down('xs')]: {
      textTransform: 'inherit',
      fontSize: '11px',
      paddingLeft: '5px',
      paddingRight: '5px'
    }
  }
}))

export default function ProfileInfo() {
  const router = useRouter()
  const { pid } = router.query

  if (!pid) {
    return null
  }

  return (
    <Layout pageTitle="pages_titles.application">
      <ProfileInfoContent id={pid} />
    </Layout>
  )
}

export const getServerSideProps = async (context) => ({ props: await allPagesProps(context) })

const interviewStyles = notScheduled => makeStyles((theme) => ({
  button: {
    fontSize: '14px',
    color: notScheduled ? theme.palette.info.main : theme.palette.warning.main
  },
  message: {
    fontSize: '14px',
    color: notScheduled ? theme.palette.grey : theme.palette.warning.main,
    '& span': {
      fontWeight: 'bold'
    }
  },
  icon: {
    color: theme.palette.warning.main,
    marginRight: '5px'
  }
}))

const Qualification = () => {
  const application = useSelector((state) => state.application)

  const commentsCount = useSelector(({ comments }) => Object.keys(comments || {}).length)
  const candidate = useSelector((state) => state.candidate.data)

  const [editing, setEditing] = useState(false)

  const update = useUpdate()
  const auth = useAuth()
  const alert = useAlert()

  const savePool = (id, value) => auth.fetch(`profile/applications/${id}`, { method: 'PATCH', body: { application: { pool: value } } })

  const handleSwitchChange = async (e) => {
    update(['application', 'data', 'pool'], e.target.checked)

    savePool(application.data.id, e.target.checked)
      .then(() => {
        alert('notice', <Trans i18nKey="alerts.saved_data" />)
      })
      .catch(() => {
        alert('error', <Trans i18nKey="alerts.saved_error" />)
      })

    if (!e.target.checked) {
      application.data.other_applications
        .filter((application) => application.pool)
        .map((selectedApplication, idx) => {
          savePool(selectedApplication.id, false)
            .then(() => update(['application', 'data', 'other_applications', idx, 'pool'], false))
            .catch(() => {
              alert('error', <Trans i18nKey="alerts.saved_error" />)
            })
        })
    }
  }

  const editHandler = (event) => {
    event.stopPropagation()
    setEditing(true)
  }
  const isCandidateInPool = () => {
    if (!application.data.pool && application.data.other_applications.some((application) => application.pool)) return true

    return application.data.pool
  }
  const closeHandler = () => setEditing(false)

  return (
    <Box my={3}>
      <Container>
        {editing && (
          <Dialog open onClose={closeHandler}>
            <DialogContent>
              <EditCandidate id={candidate.id} closeHandler={closeHandler} />
            </DialogContent>
          </Dialog>
        )}

        <Grid container justifyContent="center">
          <Grid item md={7}>
            <ApplicationStatus />
          </Grid>

          <Grid item md={3}>
            <FormControlLabel control={<Switch color="primary" />} label={i18n.t('main.filtering.add_vivier')} onChange={handleSwitchChange} checked={isCandidateInPool()} />
          </Grid>

          <Grid item md={2}>
            <CvTheque />
          </Grid>
        </Grid>

        <Grid container alignItems="center">
          <Grid item xs={12} md={6}>
            <Box
              style={{
                display: 'flex',
                alignItems: 'center',
                marginTop: '10px'
              }}
            >
              <Interview application={application} />
            </Box>
          </Grid>
          <Grid item xs={12} md={5} align="right">
            <Typography>
              {candidate.mine && (
                <Button onClick={editHandler} color="secondary">
                  <EditIcon /> {i18n.t('generic.edit')}
                </Button>
              )}
              {commentsCount > 0 && (
                <IconButton href="#comments" color="secondary">
                  <CommentOutlined /> {commentsCount}
                </IconButton>
              )}
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

const Interview = ({ application }) => useFetch(
  ({ fetch }) => ({
    interviews: fetch(`profile/applications/${application.data.id}/interview`)
  }),
  { hideLoading: true },
  () => {
    const [openDialog, setOpenDialog] = useState(false)
    const [interviewInfos, setInterviewInfos] = useState({})
    const interview = useSelector((state) => state.interviews)
    const candidate = useSelector((state) => state.candidate.data)

    const notScheduled = !interview.date && !interview.time

    const classes = interviewStyles(notScheduled)()

    useEffect(() => (
      setInterviewInfos({
        interview,
        application: application.data,
        offerName: application.included.job_offers[application.data.job_offer.id].label,
        candidateFullName: `${candidate.first_name} ${candidate.last_name}`
      })
    ), [notScheduled])

    return (
      <Fragment>
        {!notScheduled && <ErrorOutlineIcon className={classes.icon} />}
        <Typography
          className={classes.message}
          dangerouslySetInnerHTML={{
            __html: notScheduled ? i18n.t('profile.entreprise.interview.not_scheduled') : i18n.t('profile.entreprise.interview.scheduled', { time: `${moment(interview?.date).format('ddd')} ${interview?.date}` })
          }}
        />
        <Typography className={classes.button} style={{ margin: '0 10px 0 10px' }}>
          <Button onClick={() => setOpenDialog(true)} variant="text" color="primary">
            {notScheduled ? i18n.t('job_offer.new_job_offer.job.missing_tech_popup_button') : i18n.t('profile.entreprise.interview.edit')}
          </Button>
        </Typography>

        {openDialog && (
          <InterviewDialog
            open={openDialog}
            setOpen={(value) => setOpenDialog(value)}
            interviewInfos={interviewInfos}
          />
        )}
      </Fragment>
    )
  }
)

const getStorePathFromLocationPathname = (id, router) => {
  const path = []

  switch (router.route) {
    case '/job-offer/[pid]/applications':
      path.push('profileOffer', 'included', 'applications_recaps', id)
      break
    case '/entreprise/profile/[section]':
      path.push('profileOffers', 'included', 'applications_recaps', id)
      break
    case '/application-preview/[pid]':
      path.push('link', 'job_application')
      break
    default:
      path.push('application', 'data')
      break
  }

  return path
}

const getStateFromStorePath = (path) => useSelector((state) => path.reduce((previous, current) => previous[current], state))

export const ApplicationStatus = ({ uuid, applicationId }) => {
  const update = useUpdate()
  const auth = useAuth()
  const alert = useAlert()
  const router = useRouter()
  const classes = useStyles()

  const path = getStorePathFromLocationPathname(applicationId, router)
  const application = getStateFromStorePath(path)

  const [rejectionOpened, setRejectionOpened] = useState(false)

  const isMobile = useMediaQuery('(max-width:325px)')

  const handleStatusSwitch = (status) => () => {
    update([...path, 'status'], status)

    auth
      .fetch(`profile/applications/${uuid ? uuid : application.id}`, { method: 'PATCH', body: { application: { status } } })
      .then(() => {
        if (status !== application?.status) {
          alert('notice', <Trans i18nKey="alerts.saved_status_changes" />)
        }

        if (status === 'rejected') {
          setRejectionOpened(true)
        }
      })
      .catch(() => {
        alert('error', <Trans i18nKey="alerts.saved_error" />)
      })
  }

  if (!application) return null

  return (
    <Fragment>
      {rejectionOpened && (
        <Dialog open onClose={() => setRejectionOpened(false)}>
          <RejectionDialog onClose={() => setRejectionOpened(false)} applicationId={applicationId} uuid={uuid} />
        </Dialog>
      )}
      <Grid container direction={isMobile ? 'column' : 'row'}>
        <Grid item md={7}>
          <ButtonGroup orientation={isMobile ? 'vertical' : 'horizontal'}>
            {Object.entries(STATUSES).map(([slug, status]) => (
              <Button
                variant={application.status === slug ? 'contained' : 'outlined'}
                onClick={handleStatusSwitch(slug)}
                className={classes[`${slug}Button`]}
                style={{ fontWeight: 'normal' }}
              >
                {slug === application.status && status.icon} {status.label}
              </Button>
            ))}
          </ButtonGroup>
        </Grid>
      </Grid>
    </Fragment>
  )
}

const CvTheque = () => {
  const [anchorEl, setAnchorEl] = useState(null)
  const application = useSelector((state) => state.application)
  const auth = useAuth()
  const alert = useAlert()
  const update = useUpdate()

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }
  const changeApplicationDeletion = (id, value) => auth.fetch(`profile/applications/${id}`, { method: 'PATCH', body: { application: { deleted: value } } })

  const updateApplications = () => {
    changeApplicationDeletion(application.data.id, !application.data.deleted)
      .then(() => {
        update(['application', 'data', 'deleted'], !application.data.deleted)
        alert('notice', <Trans i18nKey="alerts.saved_data" />)
      })
      .catch(() => {
        alert('error', <Trans i18nKey="alerts.saved_error" />)
      })

    application.data.other_applications
      .filter((otherApp) => otherApp.deleted === application.data.deleted)
      .map((selectedApplication, idx) => {
        changeApplicationDeletion(selectedApplication.id, !application.data.deleted)
          .then(() => {
            update(['application', 'data', 'other_applications', idx, 'deleted'], !application.data.deleted)
          })
          .catch(() => {
            alert('error', <Trans i18nKey="alerts.saved_error" />)
          })
      })
  }

  const handleButtonClick = () => {
    if (!application.data.deleted) confirm(i18n.t('main.filtering.confirm_removal')) && updateApplications()
    else updateApplications()
  }

  const buttonInfos = application.data.deleted
    ? { label: i18n.t('main.filtering.add_to_cvTheque'), color: 'primary' }
    : { label: i18n.t('main.filtering.remove_from_cvTheque'), color: 'secondary' }

  if (!application) return null

  return (
    <Fragment>
      <IconButton onClick={handleClick}>
        <MenuIcon />
      </IconButton>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose} style={{ top: '50px' }}>
        <MenuItem>
          <Button color={buttonInfos.color} onClick={handleButtonClick}>
            {buttonInfos.label}
          </Button>
        </MenuItem>
      </Menu>
    </Fragment>
  )
}

export const MarkAsSeen = ({ source = 'application' }) => {
  const auth = useAuth()

  const applicationId = useSelector((state) => state.application.data.id)

  useEffect(() => {
    auth.fetch(`profile/applications/${applicationId}`, { method: 'PATCH', body: { application: { seen: true } } }).catch(() => {
      alert('error', <Trans i18nKey="alerts.saved_error" />)
    })
  }, [])

  return null
}

export const ProfileInfoEdition = () => {
  return null
}

const fetchApplications = (fetch) => (id) => {
  return fetch(`profile/applications/${id}`)
}

const ProfileInfoContent = ({ id }) =>
  useFetch(
    ({ fetch }) => ({
      application: fetchApplications(fetch)(id),
      reasons: fetch('rejection_reasons').then(mapByIds)
    }),
    { params: [id] },
    ({ application }) => {
      const candidate = useSelector((state) => state.candidate)

      const update = useUpdate()
      useEffect(() => {
        const applicationCandidate = Object.values(application.included.candidates)[0]

        update(['candidate'], {
          ...{ data: applicationCandidate },
          included: application.included
        })
      }, [application])

      if (!candidate) {
        return null
      }

      return (
        <div>
          <MarkAsSeen />
          <Box mt={4} mb={2}>
            <Navigation />
            <Qualification />
          </Box>
          <PortfolioContent />
          <Assessment />
          <CoverLetter />

          <Container>
            <Box mt={8}>
              <Comments candidateId={candidate.data.id} />
            </Box>

            <Box mt={8}>
              <OtherApplications />
            </Box>
          </Container>
        </div>
      )
    }
  )

const Assessment = () => {
  const assessment = useSelector(
    ({
      application: {
        data: { assessment_answers }
      }
    }) => assessment_answers
  )

  if (!assessment || Object.keys(assessment).length === 0) return null

  return (
    <Container maxWidth="md">
      <Box mb={3} mt={5}>
        <Card>
          <CardContent>
            <Grid container spacing={3} direction="column">
              {Object.values(assessment).map((answer) => (
                <Grid item>
                  <Typography variant="h3">{answer.question_label}</Typography>

                  {typeof answer.value === 'string' && (
                    <blockquote>
                      <ReactMarkdown skipHtml linkTarget="_blank">
                        {answer.value}
                      </ReactMarkdown>
                    </blockquote>
                  )}

                  {typeof answer.value === 'object' && (
                    <ul>
                      {Object.values(answer.value).map((choice) => (
                        <li>
                          <Typography>{choice}</Typography>
                        </li>
                      ))}
                    </ul>
                  )}
                </Grid>
              ))}
            </Grid>
          </CardContent>
        </Card>
      </Box>
    </Container>
  )
}

const EditCandidate = ({ id, closeHandler }) =>
  useFetch(
    ({ fetch }) => ({
      technologies: fetch('technologies?ignore_picture=true').then((results) => mapByIds(results.data))
    }),
    ({ technologies: technologiesList }) => {
      const update = useUpdate()

      const applicationId = useSelector((state) => state.application.data.id)
      const candidate = useSelector((state) => state.application.included.candidates[id])

      const [firstName, setFirstName] = useState(candidate.first_name)
      const [lastName, setLastName] = useState(candidate.last_name)
      const [email, setEmail] = useState(candidate.email)
      const [phone, setPhone] = useState(candidate.phone)
      const [technologies, setTechnologies] = useState(candidate.technology_ids.map((id) => technologiesList[id]))

      const [sending, setSending] = useState(false)

      const auth = useAuth()

      const submitHandler = (event) => {
        event.preventDefault()

        setSending(true)

        const candidateToSend = {
          first_name: firstName,
          last_name: lastName,
          email,
          phone,
          technology_ids: technologies.map(({ id }) => id)
        }

        auth
          .fetch(`profile/candidates/${candidate.id}`, {
            method: 'PATCH',
            body: { candidate: candidateToSend }
          })
          .then(() => {
            fetchApplications(auth.fetch)(applicationId).then((result) => {
              update(['application'], result)
              closeHandler()
            })
          })
          .catch(() => setSending(false))
      }

      return (
        <Fragment>
          <Box mb={3}>
            <Alert severity="info">
              <Trans i18nKey="entreprise.profile.application.you_can_edit" />
            </Alert>
          </Box>
          <form onSubmit={submitHandler}>
            <Grid container spacing={6}>
              <Grid item xs={6}>
                <TextField label="Nom" required fullWidth value={firstName} onChange={({ target: { value } }) => setFirstName(value)} />
              </Grid>
              <Grid item xs={6}>
                <TextField label="Prénom" required fullWidth value={lastName} onChange={({ target: { value } }) => setLastName(value)} />
              </Grid>
              <Grid item xs={6}>
                <TextField label="Email" required fullWidth value={email} onChange={({ target: { value } }) => setEmail(value)} />
              </Grid>
              <Grid item xs={6}>
                <TextField label="Téléphone" required fullWidth value={phone} onChange={({ target: { value } }) => setPhone(value)} />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  multiple
                  options={Object.values(technologiesList).sort(byLabel)}
                  getOptionLabel={(option) => option.label}
                  renderInput={(params) => <TextField {...params} label="Technologies" />}
                  onChange={(_, options) => setTechnologies(options)}
                  value={technologies}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography align="right">
                  <Button variant="text" onClick={closeHandler}>
                    <Trans i18nKey="generic.cancel" />
                  </Button>
                  <Button color="primary" variant="contained" type="submit" disabled={sending}>
                    {sending && <CircularProgress style={{ width: '30px', height: '30px', verticalAlign: 'middle' }} />} <Trans i18nKey="generic.save" />
                  </Button>
                </Typography>
              </Grid>
            </Grid>
          </form>
        </Fragment>
      )
    }
  )

const arrayItemFromStringCode = (string, array) =>
  array[
  string
    .split('')
    .map((word) => word.charCodeAt(0))
    .reduce((sum, item) => sum + item, 0) % array.length
  ]

const SAVE_DRAFT_INTERVAL = 5000
const SAVING_BUTTON_APPEARANCE = 1000

const CommentForm = ({ currentComment, candidateId, onSubmit }) => {
  const [comment, setComment] = useState(currentComment?.comment)
  const [submitting, setSubmitting] = useState(false)

  const [draftId, setDraftId] = useState('')

  const [commentChange, setCommentChange] = useState(false)

  const update = useUpdate()
  const auth = useAuth()

  const editing = Boolean(currentComment?.id)

  const submitHandler = (event) => {
    event.preventDefault()

    auth
      .fetch(`profile/candidates/${candidateId}/comments/${editing ? currentComment.id : ''}`, {
        method: editing ? 'PATCH' : 'POST',
        body: { comment: { comment, status: 'submitted' } }
      })
      .then((resource) => {
        update(['comments', resource.id], resource)
        document.location = `#comment-${resource.id}`
        onSubmit && onSubmit()
      })
  }

  const saveDraft = (idComment, body) => {
    setSubmitting(true)
    auth
      .fetch(`profile/candidates/${candidateId}/comments/${idComment}`, {
        method: idComment ? 'PATCH' : 'POST',
        body
      })
      .then((resource) => {
        setDraftId(resource.id)

        setTimeout(() => {
          setSubmitting(false)
        }, SAVING_BUTTON_APPEARANCE)
      })
      .catch(() => {
        setSubmitting(false)
      })
  }

  useEffect(() => {
    const interval = setInterval(() => {
      if (editing && currentComment.status === 'submitted') return false
      if (!commentChange) return false

      saveDraft(editing ? currentComment.id : draftId, { comment: { comment, status: 'draft' } }, editing)
      setCommentChange(false)
    }, SAVE_DRAFT_INTERVAL)

    return () => clearInterval(interval)
  })

  const changeMarkdownHandler = (value) => {
    setCommentChange(true)
    setComment(value)
  }

  return (
    <form onSubmit={submitHandler}>
      <Grid container spacing={2} direction="column">
        <Grid item>
          <MarkdownEditor placeHolder={i18n.t('entreprise.profile.application.comments.placeholder')} defaultValue={comment} onChange={changeMarkdownHandler} />
        </Grid>
        <Grid item>
          <Button type="submit" variant="contained" style={{ width: '100%' }} disabled={!comment || submitting}>
            <Trans i18nKey={submitting ? 'entreprise.profile.application.comments.saving_draft' : 'generic.save'} />
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}

const COMMENTOR_NAME_FALLBACK = 'Super Admin'

const Comments = ({ candidateId }) => {
  return useFetch(
    ({ fetch }) => ({
      comments: fetch(`profile/candidates/${candidateId}/comments`).then(mapByIds)
    }),
    [candidateId],
    ({ comments }) => {
      const [editId, setEditId] = useState()

      return (
        <Box mt={4} id="comments">
          <Typography variant="h2">
            <Trans i18nKey="entreprise.profile.application.comments.title" /> ({Object.values(comments).filter(({ status }) => status === 'submitted').length})
          </Typography>

          {!Object.values(comments).some((comment) => comment.status === 'draft') && (
            <Card>
              <CardContent>
                <CommentForm candidateId={candidateId} />
              </CardContent>
            </Card>
          )}

          <Card>
            <CardContent>
              <Grid container direction="column-reverse">
                {Object.values(comments).map((comment) => (
                  <div>
                    {comment.status === 'draft' ? <CommentForm candidateId={candidateId} currentComment={comment} onSubmit={() => setEditId(null)} /> : <div />}

                    {comment.status === 'submitted' ? (
                      <Grid item>
                        <Paper id={`comment-${comment.id}`} className="hightlight">
                          <Box my={3}>
                            <Divider />
                          </Box>
                          <Grid container>
                            <Grid item xs={1}>
                              <Grid container alignItems="center" direction="column">
                                <Grid item>
                                  <Avatar
                                    style={{
                                      backgroundColor: arrayItemFromStringCode(multiWordInitials(comment.commentor.name || COMMENTOR_NAME_FALLBACK), CHIP_COLORS)
                                    }}>
                                    {multiWordInitials(comment.commentor.name || COMMENTOR_NAME_FALLBACK)}
                                  </Avatar>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item xs={9}>
                              <Typography variant="h2">Par {comment.commentor.name || COMMENTOR_NAME_FALLBACK}</Typography>
                              <Typography variant="body2">
                                <Trans i18nKey="entreprise.profile.application.comments.at" /> {moment(comment.created_at).format('DD MMMM YYYY HH:mm')}
                                {comment.editable && (
                                  <IconButton onClick={() => setEditId(comment.id)}>
                                    <EditIcon />
                                  </IconButton>
                                )}
                              </Typography>

                              {editId !== comment.id && <ReactMarkdown>{comment.comment}</ReactMarkdown>}

                              {editId === comment.id && <CommentForm candidateId={candidateId} currentComment={comment} onSubmit={() => setEditId(null)} />}
                            </Grid>
                          </Grid>
                        </Paper>
                      </Grid>
                    ) : (
                      <div />
                    )}
                  </div>
                ))}
              </Grid>
            </CardContent>
          </Card>
        </Box>
      )
    }
  )
}

const RejectionDialog = ({ onClose, applicationId, uuid }) => {
  const [sending, setSending] = useState(false)

  const reasons = useSelector((state) => state.reasons)

  const router = useRouter()

  const path = getStorePathFromLocationPathname(applicationId, router)
  const application = getStateFromStorePath(path)

  useEffect(() => {
    if (application.new_rejection_reason && !application?.rejection_reason_id) {
      application.rejection_reason_id = 'other'
    }
  }, [])

  const auth = useAuth()

  const handler = useChangeHandler(application, ...path)

  const submitHandler = (event) => {
    event.preventDefault()

    setSending(true)

    const { rejection_reason_id, new_rejection_reason, rejection_extra_message } = application

    const savingApplication = { new_rejection_reason, rejection_extra_message }
    if (rejection_reason_id !== 'other') {
      savingApplication.rejection_reason_id = rejection_reason_id
    }

    auth
      .fetch(`profile/applications/${!uuid ? application.id : uuid}`, {
        method: 'PATCH',
        body: { application: savingApplication }
      })
      .then(() => {
        onClose()
      })
      .catch(() => {
        setSending(false)
        alert('error', <Trans i18nKey="alerts.saved_error" />)
      })
  }

  const isSent = Boolean(application?.rejection_notification_sent_at)

  return (
    <form onSubmit={submitHandler}>
      <DialogTitle>
        <Trans i18nKey="entreprise.profile.rejection_popup.title" />
      </DialogTitle>

      <DialogContent style={{ paddingTop: '20px', paddingBottom: '30px' }}>
        <DialogContentText>
          {isSent && (
            <Typography>
              <Trans i18nKey="entreprise.profile.rejection_popup.content_text" />
            </Typography>
          )}

          {!isSent && (
            <Typography>
              <Trans i18nKey="entreprise.profile.rejection_popup.content_text_new" />
            </Typography>
          )}
        </DialogContentText>

        {isSent && (
          <Fragment>
            <strong>
              <Trans i18nKey="entreprise.profile.rejection_popup.content_reason" />
            </strong>{' '}
            {application.rejection_reason_id && application.rejection_reason_id !== 'other' ? reasons[application.rejection_reason_id]?.label : application.new_rejection_reason}
          </Fragment>
        )}

        {!isSent && (
          <Fragment>
            <RadioGroup {...handler.default('rejection_reason_id')} value={application.rejection_reason_id?.toString() || ''}>
              {Object.values(reasons || {}).map(({ id, label }) => (
                <FormControlLabel value={id.toString()} control={<Radio required />} label={label} />
              ))}
              <FormControlLabel value={'other'} control={<Radio required />} label={<Trans i18nKey="entreprise.profile.rejection_popup.select_other" />} />
            </RadioGroup>

            {application?.rejection_reason_id === 'other' && (
              <Grid container direction="row" spacing={2}>
                <Grid item xs={2}>
                  <Typography align="right">
                    <SubdirectoryArrowRightIcon />
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    label={i18n.t('entreprise.profile.rejection_popup.other_label')}
                    {...handler.default('new_rejection_reason')}
                    required
                    placeholder={i18n.t('entreprise.profile.rejection_popup.other_placeholder')}
                    fullWidth
                  />
                </Grid>
              </Grid>
            )}
          </Fragment>
        )}

        <Box my={3}>
          <Divider />
        </Box>

        {!isSent && <TextField label={i18n.t('entreprise.profile.rejection_popup.extra_message_label')} {...handler.default('rejection_extra_message')} fullWidth multiline />}

        {isSent && application?.rejection_extra_message && (
          <pre style={{ whiteSpace: 'pre-line', fontFamily: 'inherit' }}>
            <strong>
              <Trans i18nKey="entreprise.profile.rejection_popup.extra_message_display" />
            </strong>{' '}
            {application.rejection_extra_message}
          </pre>
        )}
      </DialogContent>

      <DialogActions style={{ backgroundColor: '#f5f5f5' }}>
        <Button variant="contained" onClick={onClose}>
          <Trans i18nKey="entreprise.profile.rejection_popup.cancel" />
        </Button>

        {!isSent && (
          <Button variant="contained" color="primary" type="submit" disabled={sending}>
            <Trans i18nKey="entreprise.profile.rejection_popup.send" />
          </Button>
        )}
      </DialogActions>
    </form>
  )
}

const OtherApplications = () =>
  useFetch(
    ({ fetch }) => ({
      jobs: fetch('jobs')
    }),
    ({ jobs }) => {
      const otherApplication = useSelector((state) => state.application.data.other_applications)
      const classes = useStatusesStyles()

      if (otherApplication.length === 0) {
        return null
      }

      return (
        <Fragment>
          <Typography variant="h2">{i18n.t('profile.entreprise.application.also_applied_to')}</Typography>
          <Grid container spacing={2}>
            {otherApplication.map((application) => (
              <Grid item xs={12} md={6}>
                <Card style={{ cursor: 'pointer' }}>
                  <CardActionArea href={`/entreprise/profile/application/${application.hashid}`}>
                    <CardContent>
                      <Grid container spacing={2}>
                        <Grid item xs={9}>
                          <Typography variant="h4">{application.label}</Typography>
                        </Grid>
                        <Grid item xs={3}>
                          <Chip
                            label={ApplicationStatuses[application.status].label}
                            className={classes[`${application.status}Chip`]}
                            icon={ApplicationStatuses[application.status].icon}
                          />
                        </Grid>

                        <Grid item xs={6}>
                          <Typography color="textSecondary" align="left">
                            {jobs.find((job) => job.id === application.job_id).label}
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                          <Typography color="textSecondary" align="right">
                            {i18n.t('profile.entreprise.annonce_tab.submitted', { time: moment(application.created_at).format('DD MMMM YYYY') })}
                          </Typography>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Fragment>
      )
    }
  )
